<ng-container *transloco="let t; prefix: 'profile'">
  <ion-list lines="none" class="bg-transparent">
    <ion-item lines="none">
      <ion-toggle
        justify="space-between"
        [checked]="themeService.darkMode()"
        (ionChange)="onDarkModeChange($event)"
      >
        {{ t('dark-mode') }}
      </ion-toggle>
    </ion-item>

    <ion-item lines="none">
      <ion-toggle
        justify="space-between"
        [checked]="themeService.highContrast()"
        (ionChange)="onHighContrastChange($event)"
      >
        {{ t('high-contrast') }}
      </ion-toggle>
    </ion-item>

    <ion-item lines="none">
      <ion-toggle
        justify="space-between"
        [checked]="themeService.reducedMotion()"
        (ionChange)="onReducedMotionChange($event)"
      >
        {{ t('reduced-motion') }}
      </ion-toggle>
    </ion-item>

    <ion-item lines="none">
      <ion-select
        [label]="t('text-size')"
        labelPlacement="stacked"
        [value]="themeService.fontSize()"
        interface="popover"
        (ionChange)="onFontSizeChange($event)"
      >
        <ion-select-option value="small">{{ t('small') }}</ion-select-option>
        <ion-select-option value="medium">{{ t('medium') }}</ion-select-option>
        <ion-select-option value="large">{{ t('large') }}</ion-select-option>
        <ion-select-option value="xlarge">{{ t('extra-large') }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</ng-container>
